<div>
    <mat-card appearance="outlined">
        <div class="editor-form-wrapper">
            <ngx-monaco-editor class="monaco-editor-wrapper" [options]="editorOptions" [uri]="modelUri"
                [(ngModel)]="value" (init)="editorInit($event)"></ngx-monaco-editor>
        </div>
    </mat-card>
</div>